import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "./ProjectCardSkeleton.module.scss";

const ProjectCardSkeleton = ({ count = 1 }) => {
  return (
    <section className={styles.projectCardSkeleton}>
      {Array.from({ length: count }).map((_, index) => (
        <div className={styles.card} key={index}>
          {/* Title */}
          <Skeleton height={20} width={`60%`} />

          {/* Subtitle */}
          <div className={styles.subtitle}>
            <Skeleton height={14} width={`20%`} />
          </div>

          {/* Divider */}
          <div className={styles.divider} />

          {/* Bottom Info */}
          <div className={styles.infoRow}>
            <div className={styles.infoBlock}>
              <Skeleton width={28} height={28} />
              <div>
                <Skeleton width={80} height={10} />
                <Skeleton width={30} height={14} />
              </div>
            </div>
            <div className={styles.infoBlock}>
              <Skeleton width={28} height={28} />
              <div>
                <Skeleton width={80} height={10} />
                <Skeleton width={30} height={14} />
              </div>
            </div>
            {/* <div className={styles.infoBlock}>
              <Skeleton circle width={20} height={20} />
              <div>
                <Skeleton width={60} height={10} />
                <Skeleton width={100} height={14} />
              </div>
            </div> */}
          </div>
        </div>
      ))}
    </section>
  );
};

export default ProjectCardSkeleton;
